export function truncateAtWord(str: string, maxLen: number): string {
  const trimmedStr = str.trim();

  if (trimmedStr.length <= maxLen) {
    return trimmedStr;
  }

  let cut = trimmedStr.slice(0, maxLen);
  const lastCharInCut = cut.at(-1);
  const nextChar = trimmedStr[maxLen];
  const isWordBoundary =
    (lastCharInCut !== undefined && /\s/u.test(lastCharInCut)) ||
    (nextChar !== undefined && /\s/u.test(nextChar));

  cut = cut.trimEnd();

  if (!isWordBoundary) {
    const lastSpace = cut.lastIndexOf(' ');
    if (lastSpace !== -1) {
      cut = cut.slice(0, lastSpace).trimEnd();
    }
  }

  cut = cut.replace(/[^\p{L}\p{N}]+$/u, '');

  return cut.trim();
}
